// extracted by mini-css-extract-plugin
export default {"link":"BackButton_link__fKczz","icon":"BackButton_icon__DIJTh","text":"BackButton_text__x9Y39"};